<template>
  <div class="col-md-6">
    <div class="heading">
      <h2 class="title">{{ translations.registerTitle }}</h2>
      <p>
        {{ translations.registerSubTitle }}
      </p>
    </div>
    <!-- End .heading -->
    <form @submit.prevent.stop="submitForm()">
      <input
        type="text"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.firstName"
        v-model="firstName"
      />
      <form-error :model="$v.firstName" :dirty="$v.$dirty" label="Ime" />
      <input
        type="text"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.lastName"
        v-model="lastName"
      />
      <form-error :model="$v.lastName" :dirty="$v.$dirty" label="Prezime" />
      <input
        type="text"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.company"
        v-model="company"
      />
      <form-error :model="$v.company" :dirty="$v.$dirty" label="Kompanija" />
      <input
        type="tel"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.phone"
        v-model="phoneNumber"
      />
      <form-error :model="$v.phoneNumber" :dirty="$v.$dirty" label="Telefon" />
      <input
        type="text"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.address"
        v-model="address"
      />
      <form-error :model="$v.address" :dirty="$v.$dirty"
        :label="translations.forms.labels.address" />
      <vue-select
        v-model="countryId"
        :options="countries"
        :custom-label="customLabel"
        class="vue-select"
        id="country-id"
        :loading="isLoading"
        placeholder="Izaberite državu"
        @search-change="getCountries"
        @select="getTownsByCountryId"
      >
        <template slot="noOptions">{{ translations.listIsEmpty }}</template>
        <template slot="noResult">
          {{ translations.noResultsAccordingToTheGivenParameters }}</template>
      </vue-select>
      <form-error :model="$v.countryId" :dirty="$v.$dirty" label="Država" />

      <vue-select
        v-model="townId"
        :options="towns"
        :custom-label="customLabel"
        class="vue-select"
        id="town-id"
        :loading="isLoading"
        placeholder="Izaberite grad"
        @search-change="getTowns"
      >
        <template slot="noOptions">{{ translations.listIsEmpty }}</template>
        <template slot="noResult">
          {{ translations.noResultsAccordingToTheGivenParameters }}</template>
      </vue-select>
      <form-error :model="$v.townId" :dirty="$v.$dirty" label="Grad" />

      <vue-select
        class="vue-select"
        :options="areas"
        :multiple="true"
        :close-on-select="false"
        v-model="interestsAreas"
        :custom-label="customLabel"
        label="name"
        track-by="id"
        id="interest-areas-id"
        placeholder="Izaberite interesna područja"
      >
        <template slot="noOptions">{{ translations.listIsEmpty }}</template>
        <template slot="noResult">
          {{ translations.noResultsAccordingToTheGivenParameters }}
        </template>
      </vue-select>
      <!-- End .select-custom -->
      <h2 class="title mb-2">{{ translations.registerSectionLoginDataTitle }}</h2>
      <input
        type="email"
        class="form-control mw-75"
        :placeholder="translations.forms.labels.email"
        v-model="email"
      />
      <form-error :model="$v.email" :dirty="$v.$dirty" label="Email" />

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="newsletter-signup"
          v-model="termsAndConditions"
        />
        <label class="custom-control-label" for="newsletter-signup">
          {{ translations.acceptTerms }}
        </label>
      </div>

      <label class="error" v-if="!termsAndConditions && $v.$dirty">
        {{ translations.termsOfUseIsMandatory }}
      </label>

      <div class="panel card-sign message">
              <div v-if="requestSubmited" class="alert alert-info">
                {{requestMessage}}
              </div>
              <div v-if="alreadyUsedEmail" class="alert alert-danger">
                {{requestMessage}}
              </div>
            </div>
      <!-- End .custom-checkbox -->
      <div class="form-footer">
        <button type="submit" class="btn btn-primary">{{ translations.registerSubmit }}</button>
      </div>
      <!-- End .form-footer -->
    </form>
  </div>
</template>

<script>
import VueSelect from 'vue-multiselect';

import api from '@/services/api';
import { translations } from '@/mixins';

import FormError from '@/components/shared/form-errors/FormError.vue';
import validations from './validation-schema/register';

export default {
  name: 'Register',
  mixins: [translations],
  components: {
    VueSelect,
    FormError,
  },
  validations,
  data() {
    return {
      isLoading: false,
      firstName: '',
      lastName: '',
      countryId: null,
      townId: null,
      interestsAreas: [],
      requestSubmited: false,
      alreadyUsedEmail: false,
      requestMessage: '',
      phoneNumber: '',
      email: '',
      password: '',
      confirmPassword: '',
      address: '',
      company: '',
      termsAndConditions: false,
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    },
    countries() {
      return this.$store.getters.getCountries.map(({ id, title }) => ({ id, title }));
    },
    towns() {
      return this.$store.getters.getTowns.map((item) => ({
        id: item.id,
        title: item.title,
      }));
    },
    areas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({
        id,
        title,
      }));
    },
  },
  mounted() {
    this.$store.dispatch('getCountries', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch('getInterestsAreas', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid || !this.termsAndConditions) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      const {
        firstName,
        lastName,
        phoneNumber,
        email,
        password,
        address,
        townId,
        countryId,
        interestsAreas,
        company,
      } = this;

      api
        .register({
          firstName,
          lastName,
          phoneNumber,
          email,
          password,
          address_1: address,
          address_2: address,
          countryId: parseInt(countryId.id, 10),
          townId: parseInt(townId.id, 10),
          interestsAreasIds: interestsAreas.map(({ id }) => id),
          companyTitle: company,
        })
        .then((response) => {
          this.requestMessage = response.data.info;
          this.$emit('registered', true);
          if (response.data.isValid) {
            this.requestSubmited = true;
            this.alreadyUsedEmail = false;
          } else {
            this.requestSubmited = false;
            this.alreadyUsedEmail = true;
          }
        })
        .catch((err) => {
          // this.$toast.error(err.response.data.info)
          this.requestMessage = err.response.data.info;
          this.requestSubmited = false;
          this.alreadyUsedEmail = true;
        });
    },
    getTownsByCountryId({ id }) {
      this.$store
        .dispatch('getTowns', {
          countryId: id,
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    customLabel({ title }) {
      return title;
    },
    getTowns(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getTowns', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    getCountries(query) {
      if (query) {
        this.isLoading = true;
        this.$store
          .dispatch('getCountries', {
            quickSearch: query,
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss">
.body-sign {
  max-width: 550px;
}

.vue-treeselect__control {
  max-width: 480px;
  height: 46px;
  border-radius: 0;
}

.vue-treeselect__placeholder.vue-treeselect-helper-zoom-effect-off {
  line-height: 44px;
}

.message {
  max-width: 480px;
}

.vue-treeselect__multi-value-item {
  height: 34px;
}

.vue-select {
  max-width: 480px;
  margin-bottom: 1rem;
}

label.error {
  width: 100%;
  color: #d2322d;
}
</style>
